<template>
    <section class="mt-16">
        <v-breadcrumbs
          large
          :items="crumbs"
          divider="/"
          class="pl-0"
        ></v-breadcrumbs>
  
        <h1 class="primary--text">
          <v-icon color="primary">mdi-shield-account</v-icon> <span>{{$t('state.add_crumb')}}</span>
        </h1>
  
        <div class="mt-16">
          <state method="create"></state>
        </div>
    </section>
  </template>
  <script>
  import State from '@/components/complaints/states/State'
  
  export default {
    components: {
        State
    },
    beforeCreate(){
      document.title = this.$t('app_name')
    },
    data: () => ({
      
    }),
    mounted(){
  
      if(!this.$root.session.hasPermission(["super", "states.create"])) {
        this.$router.push('/admin');
      }
  
    },
    methods:{
    },
    computed: {
      crumbs: function() {
        return [
        {
            text: this.$t('menu.dashboard'),
            disabled: false,
            to: '/admin',
            exact: true,
          },
          {
            text: this.$t('menu.states_management'),
            disabled: false,
            to: '/admin/settings/states',
            exact: true,
          },
          {
            text: this.$t('state.add_crumb'),
            disabled: true,
            to: window.location.href,
            exact: true,
          },
        ];
      }
    }
  };
  </script>
  